/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerUpRight = createReactComponent("outline", "corner-up-right", "IconCornerUpRight", [["path", { "d": "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4", "key": "svg-0" }]]);

export { IconCornerUpRight as default };
//# sourceMappingURL=IconCornerUpRight.mjs.map
